/**
 * O chat de suporte dentro do CliqCRM (29/09/2026).
 *
 * `ativo: false` quando o ambiente não tem canal de suporte, ou quando quem
 * pergunta é da própria organização de suporte. Com `ativo: true`, vêm o token
 * público do widget e a identidade JÁ assinada pelo servidor.
 */

import { z } from 'zod';

export const ChatDeSuporteSchema = z
  .object({
    ativo: z.boolean(),
    /** O token público do widget. Não é segredo: vai na página. */
    website_token: z.string().nullable(),
    /** O id da pessoa, o mesmo em todas as revendas dela. */
    identificador: z.string().nullable(),
    /** HMAC do identificador com o segredo do canal, calculado no servidor. */
    identificador_hash: z.string().nullable(),
    nome: z.string(),
    email: z.string(),
    /** A revenda de onde a pessoa está chamando agora. */
    revenda: z.string(),
  })
  .strict();

export type ChatDeSuporte = z.infer<typeof ChatDeSuporteSchema>;
